import React, { useState, useEffect } from "react";
import Autocomplete from "../../../node_modules/react-google-autocomplete";
//import CartInputField from "../Cart/CartInputField";

function CartInputAddress(props) {
  const [ErrorMsg, setErrorMsg] = useState(() => {
    const initialState = initErrorMsg();
    return initialState;
  });

  function initErrorMsg() {
    if (!props.errList || props.errList.length === 0) return "";
    let txt = "";
    let errList = props.errList.filter((el) => el.id === props.name);
    if (errList.length > 0) {
      errList.forEach((el) => (txt += el.msg + " "));
    }
    const initialState = txt;
    return initialState;
  }

  useEffect(() => {
    if (ErrorMsg === "") {
      let txt = initErrorMsg();
      if (txt !== "") setErrorMsg(txt);
    }
  }, [props.errList]);

  function checkField(ev) {
    //console.log(props);
    props.change(ev.target.value);
    if (props.required && ev.target.value.length === 0) {
      setErrorMsg("Si prega di non lasciare il campo vuoto.");
    } else {
      setErrorMsg("");
    }
  }

  const startingStyle = {
    border: "1px solid #B3B3B3",
  };
  const validStyle = {
    border: "1px solid green",
  };
  const invalidStyle = {
    border: "1px solid red",
  };
  function setStyle() {
    if (!props.required) return startingStyle;
    if (props.value.length === 0 && ErrorMsg.length === 0) return startingStyle;
    if (ErrorMsg.length === 0) return validStyle;
    else return invalidStyle;
  }

  function labelUrl(label, urlText, url) {
    let txt =
      label + " (<a target='_self' href='" + url + "'>" + urlText + "</a>)";
    return { __html: txt };
  }

  function composeLabel(labelTxt) {
    if (props.url && props.url.length > 0) {
      return (
        <label
          dangerouslySetInnerHTML={labelUrl(labelTxt, props.urlText, props.url)}
        />
      );
    } else return <label>{labelTxt}</label>;
  }

  let label = props.lbl;
  if (props.required === true && label.length > 0) label += " *";

  //console.log("PROPS");
  //console.log(props);
  return (
    <div className={props.cssClass}>
      {props.labelRight === true ? null : composeLabel(label)}

      <Autocomplete
        apiKey={props.googleMapId}
        title={props.lbl}
        placeholder="inserisci un indirizzo"
        value={props.value === null ? "" : props.value}
        style={setStyle()}
        onChange={(e) => checkField(e)}
        onPlaceSelected={(place) => {
          //const lng = place.geometry.location.lng();
          //const lat = place.geometry.location.lat();
          let civico = "";
          for (const component of place.address_components) {
            //  as google.maps.GeocoderAddressComponent[]
            const componentType = component.types[0];

            switch (componentType) {
              case "street_number": // civico
                civico = component["long_name"];
                break;

              case "route": // indirizzo
                //console.log("Selezionato: "+ component["long_name"]);
                props.change(
                  civico.length > 0
                    ? component["long_name"] + ", " + civico
                    : component["long_name"]
                );
                break;

              case "postal_code": // CAP
                props.changeCap(component["long_name"]);
                break;

              case "postal_code_suffix":
                break;

              case "locality": // Comune
                props.changeCity(component["long_name"]);
                break;

              case "administrative_area_level_1":
                break;

              case "administrative_area_level_2": // Provincia
                props.changeProv(component["short_name"]);
                break;

              case "country": // Nazione
                break;
                
              default:
                // none
            }
          }
          //console.log(place);
        }}
        options={{
          componentRestrictions: { country: ["it"] },
          fields: ["address_components", "geometry"],
          types: ["address"],
        }}
      />

      {props.labelRight === true ? composeLabel(label) : null}
      {props.imgUrl && props.imgUrl.length > 0 ? (
        <img src={props.imgUrl} alt={props.imgAlt} title={props.imgAlt} />
      ) : null}

      <div className="nota_indirizzo">
        <p>Aggiungi un numero civico, se esistente</p>
      </div>
   
      {props.labelRight === true ? <div className="clear" /> : null}

      {ErrorMsg.length > 0 ? (
        <div
          className={
            props.labelRight === true ? "errore_cart" : "campo_vuoto_cart"
          }
        >
          <p>{ErrorMsg}</p>
        </div>
      ) : null}
    </div>
  );
}

export default CartInputAddress;